// Componente de botão laranja — botão estilizado com gradiente e efeito hover
// Aceita estilos extras via prop "style" para personalização
function OrangeButton({ children, onClick, style: extraStyle }) {
  return (
    <button
      onClick={onClick}
      style={{
        width: "100%",
        maxWidth: 360,
        padding: "16px 0",
        borderRadius: 40,
        border: "none",
        background: "linear-gradient(135deg, #F2A66C 0%, #E8956A 100%)",
        color: "#fff",
        fontSize: 18,
        fontWeight: 600,
        fontFamily: "'DM Sans', sans-serif",
        cursor: "pointer",
        letterSpacing: 0.5,
        boxShadow: "0 4px 16px rgba(242,166,108,0.35)",
        transition: "transform 0.2s, box-shadow 0.2s",
        ...extraStyle,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 6px 24px rgba(242,166,108,0.5)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(242,166,108,0.35)";
      }}
    >
      {children}
    </button>
  );
}

export default OrangeButton;
